import {request} from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const schedulesInit = ({
  commit, state
}, {start, end}) => {
  start = start || state.start
  end = end || state.end
  return request(API.SCHEDULES_INIT_API, 'GET', {
    start,
    end
  }).then(res => {
    if (res && res.success) {
      commit(types.SCHEDULES_INIT, res.data)
      commit(types.CHANGE_DATE_END, end)
    }
    return res
  })
}

export const seriesInit = ({
  commit, state
}, {start, end}) => {
  start = start || state.start
  end = end || state.end
  return request(API.SCHEDULES_INIT_API, 'GET', {
    start,
    end
  }).then(res => {
    if (res && res.success) {
      commit(types.SCHEDULES_INIT, res.data)
      commit(types.CHANGE_DATE_END, end)
    }
    return res
  })
}

export const selectSchedule = ({
  commit
}, res) => {
  commit(types.SELECT_SCHEDULE, res)
}

export const changeDateRange = ({
  commit, state, dispatch
}, {value}) => {
  const {
    end
  } = state
  if (value <= end) {
    return
  }
  dispatch('schedulesInit', {
    end: value
  })
}



// WEBPACK FOOTER //
// ./src/store/schedules/actions.js